import { TPersonalAccountCochairState } from './types';

export function getListOfCountry(state: TPersonalAccountCochairState) {
  return state.listOfCountry;
}

export function getIsLoading(state: TPersonalAccountCochairState) {
  return state.isLoading;
}

export function getIsLoadingMore(state: TPersonalAccountCochairState) {
  return state.isLoadingMore;
}
